import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import config from 'cityads-v3/config';
import { RootState } from 'cityads-v3/types/reducer';
import classes from './Profile.scss';

import Card from 'cityads-v3/components/Card/Card';
import Typography from '@material-ui/core/Typography'

import {
  USER_ROLE_CODE_WEBMASTER,
} from 'cityads-v3/reducers/auth';

type MeProps = {
  forwardedRef: React.ForwardedRef<Card>
}

export function Me({
  forwardedRef
}: MeProps): JSX.Element {
  const { t } = useTranslation(['main'])

  const headerBar = useSelector((state: RootState) => state.auth.user?.headerBar)
  const owner = useSelector((state: RootState) => state.header.bar.filter(item => item.type === 'owner')[0])
  const userData = useSelector((state: RootState) => state.header.user)
  const user = useSelector((state: RootState) => state.auth.user)

  const exitLink = headerBar?.filter(item => item.type === 'exit')[0];

  const actions = [{
    title: t('header.my_account'),
    isPrimary: true,
    href: `${config.AUTH_URL}/enter`
  }, {
    title: exitLink?.data?.label,
    isPrimary: true,
    href: exitLink?.data?.url
  }];

  return (
    <Card
      classes={{ root: classes.pageContainer }}
      actions={actions}
      ref={forwardedRef}
    >
      <>
        <Typography className={classes.profile}>
          {userData?.xkey ? <div>xKey: {userData.xkey}</div> : undefined}
          {user?.user_role_code === USER_ROLE_CODE_WEBMASTER ? <div>{t('publisher')}: {user?.email}</div> : undefined}
          {owner?.data?.sudo ? (
            <div><a href={owner.data.sudo_url}>Sudo: {owner.data.sudo}</a></div>
          ) : false}
        </Typography>
      </>
    </Card>
  )
}

export default forwardRef<Card>((props, ref) => <Me {...props} forwardedRef={ref} />)
